'use client';
import { useEffect } from 'react';

const SKIP_ROUTES = [
  '/dashboard',
];

const shouldSkip = (path) =>
  SKIP_ROUTES.some(route => path.startsWith(route));

export default function InstantLoaderTrigger() {
  useEffect(() => {
    let safetyTimer = null;
    let cancelTimer = null;
    let prevPath = window.location.pathname + window.location.search;
    let isNavigating = false;

    const showLoader = () => {
      isNavigating = true;
      window.dispatchEvent(new Event('instant-loader:show'));
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(() => hideLoader(), 8000);
    };

    const hideLoader = () => {
      isNavigating = false;
      window.dispatchEvent(new Event('instant-loader:hide'));
      clearTimeout(safetyTimer);
      clearTimeout(cancelTimer);
    };

    const originalPushState = window.history.pushState.bind(window.history);
    const originalReplaceState = window.history.replaceState.bind(window.history);

    window.history.pushState = (state, title, url) => {
      const nextPath = url ? url.toString() : '';
      const cleanNext = nextPath.split('?')[0];
      if (nextPath && nextPath !== prevPath && !shouldSkip(cleanNext)) {
        prevPath = nextPath;
        clearTimeout(cancelTimer);
        isNavigating = true;
        window.dispatchEvent(new Event('instant-loader:show'));
      } else {
        hideLoader();
      }
      return originalPushState(state, title, url);
    };

    window.history.replaceState = (state, title, url) => {
      const nextPath = url ? url.toString() : '';
      const cleanNext = nextPath.split('?')[0];
      if (nextPath && nextPath !== prevPath && !shouldSkip(cleanNext)) {
        prevPath = nextPath;
        clearTimeout(cancelTimer);
        isNavigating = true;
        window.dispatchEvent(new Event('instant-loader:show'));
      } else {
        hideLoader();
      }
      return originalReplaceState(state, title, url);
    };

    const handleClick = (e) => {
      if (shouldSkip(window.location.pathname)) return;

      // Handle <a> / <Link>
      const anchor = e.target.closest('a');
      if (anchor) {
        try {
          const destPath = new URL(anchor.href, window.location.origin).pathname;
          const isInternal =
            anchor.href &&
            anchor.href.startsWith(window.location.origin) &&
            !anchor.target &&
            !e.ctrlKey &&
            !e.metaKey &&
            !e.shiftKey &&
            anchor.href !== window.location.href &&
            !shouldSkip(destPath);
          if (isInternal) showLoader();
        } catch (_) {}
        return;
      }

      // Handle buttons
      const button = e.target.closest('button');
      if (button) {
        // âœ… Skip if button has data-tab attribute
        if (button.dataset.tab !== undefined) return; // ðŸ‘ˆ only change

        clearTimeout(cancelTimer);
        showLoader();
        cancelTimer = setTimeout(() => {
          if (!isNavigating) hideLoader();
        }, 800);
        return;
      }

      // Handle div/span with data-navigate
      const clickable = e.target.closest('[data-navigate]');
      if (clickable) {
        clearTimeout(cancelTimer);
        showLoader();
        cancelTimer = setTimeout(() => {
          if (!isNavigating) hideLoader();
        }, 800);
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      clearTimeout(safetyTimer);
      clearTimeout(cancelTimer);
    };
  }, []);

  return null;
}